module.exports = __webpack_public_path__ + "img/banner.86a97196.jpg";